import $ from 'jquery';

class Authors {
    constructor () {
        this.$wrapper = $('.js-authors');
        this.$header = $('.js-authors-header');
        this.$content = $('.js-authors-content');

        this.$header.on('click', $.proxy(this.toggleContent, this)).attr('aria-expanded', 'true');
    }

    toggleContent (e) {
        const $elem = $(e.currentTarget);

        $elem.closest(this.$header).toggleClass('is-open').attr('aria-expanded', 'true');
        $elem.closest(this.$wrapper).find(this.$content).slideToggle(300);

        if ($elem.closest(this.$header).hasClass('is-open')) {
            $elem.closest(this.$header).attr('aria-expanded', 'true');
        } else {
            $elem.closest(this.$header).attr('aria-expanded', 'false');
        }
    }
}

export default Authors;
